@if (isLoading) {
  <fds-loading-indicator></fds-loading-indicator>
}
@if (!isLoading) {
  <div class="fds-card-root">
    <div class="fds-card__card">
      <div class="fds-card__content fds-card__content--bottom-weighted">
        <fds-content-block fds-align="left" fds-body-full-width>
          <h2
            slot="heading"
            class="fds-content-block__heading fds-content-block__heading--level-4"
          >
            Investment Firms
          </h2>
          <p>
            Here is a list of Investment Firms you currently have access to.
            Please select an Investment Firm below, you will be able to switch
            between firms once you enter the site.
          </p>

          <div class="entitlement-group__select">
            <label
              class="entitlement-group__dropdown-title"
              for="investment-firm-select"
            >
              Select the appropriate Investment Firm
            </label>
            <fds-select
              fds-id="investment-firm-select"
              (change)="onFirmChange($event)"
              [attr.fds-selected-value]="selectedFirm"
              [attr.fds-options]="firmOptions | json"
              fds-aria-label="Select Item..."
            ></fds-select>
          </div>

          <div class="entitlement-group__actions">
            <fds-button
              id="continue-button"
              [attr.fds-disabled]="!selectedFirm || undefined"
              (click)="onContinue()"
              >Continue</fds-button
            >
          </div>
        </fds-content-block>
      </div>
    </div>
  </div>
}
